package com.oasisfeng.invaluable.social

/**
 * Same-origin cross-tab signaling over [BroadcastChannel] — the idiomatic browser bus that reaches this browser's own
 * tabs/windows (http(s) / localhost). BroadcastChannel never delivers a context its own messages, so no self-echo.
 *
 * On `file://` (opaque origins) it may not cross tabs; discovery then finds no peers on this bus and manual copy/paste
 * signaling remains available. To reach Node forms (TUI/MCP), pair this with a [WebSocketBus] via [CompositeBus].
 */
class BroadcastChannelBus(private val room: String = Signaling.ROOM) : SignalingBus {
    private var channel: dynamic = null

    override val label: String get() = "same-origin tabs ($room)"
    override val available: Boolean get() = js("typeof BroadcastChannel !== 'undefined'") as Boolean

    override fun start(onMessage: (dynamic) -> Unit) {
        channel = js("Reflect").construct(js("BroadcastChannel"), arrayOf<Any?>(room))
        channel.onmessage = fun(e: dynamic) { runCatching { onMessage(e.data) } }
    }

    override fun post(message: dynamic) { runCatching { channel.postMessage(message) } }

    override fun close() { runCatching { channel.close() }; channel = null }
}
